import { DefaultNumberTransformer, NumberTypes } from '@ngneat/transloco-locale';

export class CustomNumberTransformer extends DefaultNumberTransformer {
    public transform(value: number | string, type: NumberTypes, locale: string, options: Intl.NumberFormatOptions): string {
        // An ugly hack to make sure numbers are represented correctly according to Icelandic standards, the number format is shared with Germany so we use it instead
        // In some cases the icelandic locale is not supported for numbers
        if (locale == 'is-IS') {
            locale = 'de-DE';
        }

        return super.transform(value, type, locale, options);
    }
}
